import { Global, Injectable, Module, OnModuleDestroy } from '@nestjs/common';
import { ConfigService } from '@nestjs/config';
import { PrismaPg } from '@prisma/adapter-pg';
import { PrismaClient } from '@sakura/prisma';

function getConnectionString(config: ConfigService): string {
  const configuredUrl = config.get<string>('DATABASE_URL');
  if (configuredUrl) {
    return configuredUrl;
  }

  const host = config.get<string>('POSTGRES_HOST', 'localhost');
  const port = config.get<string>('POSTGRES_PORT', '5432');
  const database = config.get<string>('POSTGRES_DB', 'sakura_pharma');
  const user = encodeURIComponent(
    config.get<string>('POSTGRES_USER', 'postgres'),
  );
  const password = encodeURIComponent(
    config.getOrThrow<string>('POSTGRES_PASSWORD'),
  );

  return `postgresql://${user}:${password}@${host}:${port}/${database}?schema=public`;
}

@Injectable()
export class PrismaService extends PrismaClient implements OnModuleDestroy {
  constructor(config: ConfigService) {
    const connectionString = getConnectionString(config);
    super({ adapter: new PrismaPg({ connectionString }) });
  }

  async onModuleDestroy(): Promise<void> {
    await this.$disconnect();
  }
}

@Global()
@Module({ providers: [PrismaService], exports: [PrismaService] })
export class PrismaModule {}
